<template>
    <div>
        <material-card class="card-tabs" color="green">
            <v-flex slot="header">
                <v-tabs
                    v-model="activeTab"
                    color="transparent"
                    slider-color="white"
                >
                    <span
                        class="subheading font-weight-light mr-3"
                        style="align-self: center"
                        >Transactions:</span
                    >
                    <v-tab class="mr-3" href="#all">
                        All
                    </v-tab>
                    <v-tab class="mr-3" href="#bills">
                        Bills
                    </v-tab>
                    <v-tab class="mr-3" href="#payments">
                        Payments
                    </v-tab>
                    <v-spacer></v-spacer>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                style="color: #4caf50; background-color: #FFF"
                                class="ma-0 px-3"
                                v-on="on"
                            >
                                Statements
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile
                                v-for="(action, index) in getStatementActions()"
                                :key="index"
                                @click="action.action"
                            >
                                <v-list-tile-title>{{
                                    action.text
                                }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <v-btn
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0 px-3 ml-2"
                        v-if="currentRegID == regID"
                        @click="addStudent"
                        >Add Student</v-btn
                    >
                    <v-btn
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0 px-3 ml-2"
                        v-if="currentRegID == regID"
                        @click="openNewCreditCardModal()"
                        >New Credit Card</v-btn
                    >
                    <v-btn
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0 ml-2 px-3"
                        @click="openPaymentModal"
                        >Make Payment</v-btn
                    >
                </v-tabs>
            </v-flex>

            <v-tabs-items v-model="activeTab">
                <v-tab-item
                    v-for="tab in ['all', 'bills', 'payments']"
                    :key="tab"
                    :value="tab"
                >
                    <v-btn
                        v-if="['all', 'bills'].includes(activeTab)"
                        color="success"
                        small
                        class="mt-0"
                        @click="openAddChargeDialog"
                        >Add Charge</v-btn
                    >
                    <v-progress-linear
                        v-if="loading"
                        :indeterminate="true"
                        color="success"
                    ></v-progress-linear>
                    <v-expansion-panel v-if="!loading">
                        <v-expansion-panel-content
                            class=""
                            v-for="transaction in getTabList()"
                        >
                            <template v-slot:header class="my-0">
                                <v-layout row style="padding-top: 13px;">
                                    <v-tooltip left content-class="left">
                                        <v-btn
                                            slot="activator"
                                            class="v-btn--simple"
                                            icon
                                            style="margin-bottom: 0px; margin-top: 6px;"
                                        >
                                            <v-icon
                                                class="mr-3 ml-1"
                                                dark
                                                style="font-size: 24px;"
                                                :color="
                                                    getStatusIconColor(
                                                        transaction,
                                                    )
                                                "
                                                >{{
                                                    getStatusIcon(transaction)
                                                }}</v-icon
                                            >
                                        </v-btn>
                                        <span>{{
                                            getTransactionStatus(transaction)
                                        }}</span>
                                    </v-tooltip>

                                    <div>
                                        <v-layout row class="pa-0 ma-0">
                                            <div class="subheading mb-1">
                                                {{
                                                    getTransactionTitle(
                                                        transaction,
                                                    )
                                                }}
                                            </div>

                                            <div
                                                class="subheading ml-2 mb-1 text-info"
                                                v-if="
                                                    transaction.txnType ==
                                                        'D' &&
                                                        transaction.student
                                                            .nonUTA
                                                "
                                            >
                                                Non UTA
                                            </div>
                                        </v-layout>
                                        <div
                                            class="text--disabled subheading"
                                            v-if="transaction.txnType == 'C'"
                                        >
                                            {{
                                                getPaymentDescription(
                                                    transaction,
                                                )
                                            }}
                                        </div>
                                        <div
                                            class="text--disabled subheading"
                                            v-if="showStudentInfo(transaction)"
                                        >
                                            {{
                                                transaction.student.enrollment
                                                    .regType
                                            }}
                                        </div>
                                    </div>
                                </v-layout>
                                <v-spacer></v-spacer>
                                <div
                                    class="text--disabled body-2"
                                    v-if="transaction.note"
                                >
                                    {{ truncateText(transaction.note) }}
                                </div>
                                <div
                                    class="text--disabled body-2"
                                    v-if="
                                        showStudentInfo(transaction) &&
                                            transaction.student.enrollment
                                                .lunchDoc
                                    "
                                >
                                    Lunch Document
                                </div>
                                <div
                                    class="text--disabled body-2"
                                    v-if="
                                        showStudentInfo(transaction) &&
                                            transaction.student.enrollment
                                                .tripMoney
                                    "
                                >
                                    Trip Is Paid
                                </div>
                                <div
                                    class="text--disabled body-2"
                                    v-if="
                                        showStudentInfo(transaction) &&
                                            transaction.student.cardPrinted
                                    "
                                >
                                    Card Is Printed
                                </div>
                                <div
                                    class="text-danger subheading"
                                    v-if="
                                        transaction.txnType == 'C' &&
                                            transaction.payment &&
                                            transaction.payment.isVoided
                                    "
                                >
                                    VOIDED
                                </div>
                                <div
                                    class="text-danger subheading"
                                    v-if="isDeclined(transaction)"
                                >
                                    DECLINED
                                </div>
                                <div
                                    class="text-danger subheading"
                                    v-if="isError(transaction)"
                                >
                                    ERROR
                                </div>
                                <v-spacer></v-spacer>
                                <div
                                    class="subheading text-xs-right pr-3"
                                    v-bind:class="{
                                        'width-70': tab == 'all',
                                        'text-danger':
                                            transaction.txnType == 'C',
                                        'text-success':
                                            transaction.txnType == 'D',
                                    }"
                                >
                                    {{ getTransactionAmount(transaction) }}
                                </div>
                                <div
                                    class="body-2 text-xs-right pr-3 width-70"
                                    style="color: rgb(103 92 92);"
                                    v-if="tab == 'all'"
                                >
                                    {{ transaction.balance | currency }}
                                </div>
                            </template>
                            <v-card>
                                <v-flex xs12>
                                    <div v-if="transaction.txnType == 'C'">
                                        <v-card-text class="subheading mt-2">
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.dateCreated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Date Added:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.dateCreated
                                                            | time
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout row class="px-3 py-2">
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Payment Type:
                                                </div>
                                                <div>
                                                    {{
                                                        getPaymentType(
                                                            transaction,
                                                        )
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="
                                                    transaction.payment &&
                                                        transaction.payment
                                                            .paymentID
                                                "
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Payment ID:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.payment
                                                            .paymentID
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="
                                                    transaction.scheduleDetailID
                                                "
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Schedule Detail ID:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.scheduleDetailID
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout row class="px-3 py-2">
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Date:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.date | date
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-for="prop in getProperties(
                                                    transaction,
                                                )"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    {{ prop.name }}:
                                                </div>
                                                <div>
                                                    {{ prop.value }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.receiptNumber"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Receipt Number:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.receiptNumber
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.byUser"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    By User:
                                                </div>
                                                <div>
                                                    {{ transaction.byUser }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.lastUpdated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Last Updated:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.lastUpdated
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.userUpdated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Last Updated By:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.userUpdated
                                                    }}
                                                </div>
                                            </v-layout>

                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="
                                                    hasSchedule(
                                                        transaction.schedules,
                                                    )
                                                "
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Schedule Date:
                                                </div>
                                                <div>
                                                    {{
                                                        getScheduleDate(
                                                            transaction.schedules,
                                                        ) | time
                                                    }}
                                                </div>
                                            </v-layout>

                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="
                                                    hasSchedule(
                                                        transaction.schedules,
                                                    )
                                                "
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Schedule Enabled:
                                                </div>
                                                <div>
                                                    {{
                                                        getEnabledStatus(
                                                            transaction.schedules,
                                                        )
                                                    }}
                                                </div>
                                            </v-layout>

                                            <transaction-payment-details
                                                :transaction="transaction"
                                            ></transaction-payment-details>

                                            <div
                                                v-if="
                                                    transaction.checkDetails &&
                                                        transaction.checkDetails
                                                            .length
                                                "
                                                class="pl-1 py-2"
                                            >
                                                <div
                                                    class="font-weight-medium mb-2"
                                                >
                                                    Check Details:
                                                </div>
                                                <v-layout
                                                    row
                                                    class="px-3 py-1"
                                                    v-for="detail in transaction.checkDetails"
                                                >
                                                    <div
                                                        v-if
                                                        class="font-weight-regular mr-2"
                                                    >
                                                        Check #
                                                        {{ detail.checkNumber }}
                                                        -
                                                    </div>
                                                    <div
                                                        class="font-weight-medium"
                                                    >
                                                        {{
                                                            detail.amount
                                                                | currency
                                                        }}
                                                    </div>
                                                </v-layout>
                                            </div>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-layout row class="mb-2 pr-1">
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    small
                                                    outline
                                                    color="success"
                                                    @click="
                                                        openEmailReceiptDialog(
                                                            transaction,
                                                        )
                                                    "
                                                >
                                                    Email Receipt
                                                </v-btn>
                                                <v-btn
                                                    small
                                                    outline
                                                    color="success"
                                                    @click="
                                                        printReceipt(
                                                            transaction,
                                                        )
                                                    "
                                                >
                                                    Print Receipt
                                                </v-btn>
                                                <div
                                                    class="lapidus-transaction-button ml-2"
                                                >
                                                    <v-btn
                                                        small
                                                        dark
                                                        color="default"
                                                        v-if="
                                                            allowRefund(
                                                                transaction,
                                                            )
                                                        "
                                                        @click="
                                                            voidPayment(
                                                                transaction,
                                                            )
                                                        "
                                                    >
                                                        Refund/Void Payment
                                                    </v-btn>
                                                    <v-btn
                                                        small
                                                        dark
                                                        color="default"
                                                        class=""
                                                        v-if="
                                                            ![
                                                                'Refund',
                                                                'Void',
                                                                'Country Voucher',
                                                            ].includes(
                                                                getPaymentType(
                                                                    transaction,
                                                                ),
                                                            )
                                                        "
                                                        @click="
                                                            updatePayment(
                                                                transaction,
                                                            )
                                                        "
                                                    >
                                                        Update Payment
                                                    </v-btn>
                                                    <v-btn
                                                        small
                                                        dark
                                                        color="default"
                                                        v-if="
                                                            ![
                                                                'CC',
                                                                'Refund',
                                                                'Void',
                                                            ].includes(
                                                                getPaymentType(
                                                                    transaction,
                                                                ),
                                                            )
                                                        "
                                                        @click="
                                                            deletePayment(
                                                                transaction,
                                                            )
                                                        "
                                                    >
                                                        Delete Payment
                                                    </v-btn>
                                                    <v-btn
                                                        small
                                                        dark
                                                        color="default"
                                                        v-if="
                                                            getPaymentType(
                                                                transaction,
                                                            ) == 'CC' &&
                                                                isLaterDate(
                                                                    transaction.date,
                                                                )
                                                        "
                                                        @click="
                                                            cancelScheduledPayment(
                                                                transaction,
                                                            )
                                                        "
                                                    >
                                                        Cancel Scheduled Payment
                                                    </v-btn>
                                                </div>
                                            </v-layout>
                                        </v-card-actions>
                                    </div>

                                    <div v-else>
                                        <v-card-text class="subheading mt-2">
                                            <v-layout row class="px-3 py-2">
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Date:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.date | date
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-for="prop in getProperties(
                                                    transaction,
                                                )"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    {{ prop.name }}:
                                                </div>
                                                <div>
                                                    {{ prop.value }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.byUser"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    By User:
                                                </div>
                                                <div>
                                                    {{ transaction.byUser }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="
                                                    showStudentInfo(transaction)
                                                "
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Registrantion Type:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.student
                                                            .enrollment.regType
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout row class="px-3 py-2">
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Description:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.description
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="
                                                    transaction.student
                                                        .enrollment.regType ==
                                                        'CUSTOM' &&
                                                        showStudentInfo(
                                                            transaction,
                                                        )
                                                "
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Weeks:
                                                </div>
                                                <div>
                                                    {{
                                                        getRegisteredWeeks(
                                                            transaction,
                                                        )
                                                    }}
                                                </div>
                                            </v-layout>

                                            <v-layout row class="px-3 py-2">
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Lunch Match Type:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.student
                                                            .lunchMatchType
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.lastUpdated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Last Updated:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.lastUpdated
                                                            | time
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.userUpdated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Last Updated By:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.userUpdated
                                                    }}
                                                </div>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-layout
                                                column
                                                v-if="
                                                    showStudentInfo(transaction)
                                                "
                                            >
                                                <div
                                                    v-for="immunizationDocument in getDocumentsForStudent(
                                                        transaction.student,
                                                    )"
                                                >
                                                    <v-btn
                                                        class="mt-2 ml-2 px-3"
                                                        @click="
                                                            openDocument(
                                                                immunizationDocument,
                                                            )
                                                        "
                                                    >
                                                        <v-icon
                                                            color="red"
                                                            left
                                                            dark
                                                            >mdi-file-pdf</v-icon
                                                        >
                                                        {{
                                                            immunizationDocument.category +
                                                                " - " +
                                                                immunizationDocument.uploadedOn
                                                        }}
                                                        <v-icon right
                                                            >mdi-download</v-icon
                                                        >
                                                    </v-btn>
                                                    <v-btn
                                                        :disabled="
                                                            currentRegID !=
                                                                regID
                                                        "
                                                        v-if="
                                                            immunizationDocument.fileURL.includes(
                                                                'immunizations',
                                                            ) ||
                                                                immunizationDocument.fileURL.includes(
                                                                    'lapidus-docs',
                                                                )
                                                        "
                                                        small
                                                        icon
                                                        @click.stop="
                                                            deleteDocument(
                                                                immunizationDocument,
                                                            )
                                                        "
                                                        ><v-icon color="red"
                                                            >mdi-delete-forever</v-icon
                                                        ></v-btn
                                                    >
                                                </div>
                                            </v-layout>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                small
                                                :disabled="
                                                    currentRegID != regID
                                                "
                                                v-if="
                                                    showStudentInfo(transaction)
                                                "
                                                color="blue-grey"
                                                class="white--text mr-2"
                                                @click="
                                                    openUploadDocumentDialog(
                                                        transaction.student,
                                                    )
                                                "
                                            >
                                                Upload Document
                                                <v-icon right dark
                                                    >mdi-cloud-upload</v-icon
                                                >
                                            </v-btn>
                                            <!-- <v-btn
                                                small
                                                :disabled="
                                                    currentRegID != regID
                                                "
                                                color="blue-grey"
                                                class="white--text mr-2"
                                                :loading="uploading"
                                                @click="pickFile(transaction)"
                                            >
                                                Upload Immunization Document
                                                <v-icon right dark
                                                    >mdi-cloud-upload</v-icon
                                                >
                                            </v-btn>
                                            <input
                                                type="file"
                                                style="display: none"
                                                ref="files"
                                                accept="image/*,.pdf"
                                                @change="
                                                    onFilePicked(
                                                        $event,
                                                        transaction.student
                                                    )
                                                "
                                            /> -->
                                            <v-btn
                                                :disabled="
                                                    currentRegID != regID
                                                "
                                                small
                                                dark
                                                color="default"
                                                class="mr-2"
                                                v-if="
                                                    transaction.student
                                                        .nonUTA &&
                                                        showStudentInfo(
                                                            transaction,
                                                        )
                                                "
                                                @click="
                                                    editStudentInfo(
                                                        transaction.student,
                                                    )
                                                "
                                            >
                                                Update Student
                                            </v-btn>
                                            <v-btn
                                                small
                                                dark
                                                color="default"
                                                v-if="
                                                    showStudentInfo(transaction)
                                                "
                                                v-on:click="
                                                    openTransactionDialog(
                                                        transaction.student,
                                                    )
                                                "
                                            >
                                                Update
                                            </v-btn>
                                            <!-- <v-btn
                                                small
                                                dark
                                                color="default"
                                                v-if="
                                                    !showStudentInfo(
                                                        transaction
                                                    )
                                                "
                                                v-on:click="
                                                    openChangeAmountDialog
                                                "
                                            >
                                                Change Amount
                                            </v-btn> -->
                                            <v-btn
                                                small
                                                dark
                                                color="default"
                                                v-if="
                                                    !showStudentInfo(
                                                        transaction,
                                                    )
                                                "
                                                v-on:click="
                                                    openDeleteDialog(
                                                        transaction,
                                                    )
                                                "
                                            >
                                                delete
                                            </v-btn>
                                        </v-card-actions>
                                    </div>
                                </v-flex>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-tab-item>
            </v-tabs-items>
        </material-card>
        <edit-transaction
            ref="editTransaction"
            :student="editingStudent"
            :account="account"
            :lapidusAccount="lapidusAccount"
            :refresh="refresh"
            :country="country"
            :newStudentSelected="newStudentSelected"
            :newStudents="newStudents"
        ></edit-transaction>
        <v-dialog v-model="confirmDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Are you sure?</v-card-title
                >
                <v-card-text class="mb-2">{{
                    confirmationMessage
                }}</v-card-text>
                <v-text-field
                    class="mb-2 px-3"
                    v-if="isRefunding()"
                    type="number"
                    label="Refund Amount"
                    ref="refundAmount"
                    v-model="refundAmount"
                    :rules="refundAmountRules"
                    prefix="$"
                ></v-text-field>
                <v-text-field
                    class="px-3"
                    v-if="isRefunding()"
                    label="Refund Reason"
                    v-model="refundReason"
                ></v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="confirmDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="processAction"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="editDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-3"
                    >Update Payment</v-card-title
                >
                <div class="pa-3">
                    <v-text-field
                        v-if="editTransaction.type != 'CC'"
                        class="mb-2"
                        type="number"
                        label="Amount"
                        ref="amount"
                        prefix="$"
                        v-model="editTransaction.amount"
                        :rules="editTransaction.amountRules"
                    ></v-text-field>
                    <v-select
                        v-if="editTransaction.type != 'CC'"
                        class="mb-4"
                        :items="paymentTypes.map((v) => v.value)"
                        label="Payment Type"
                        v-model="editTransaction.type"
                        hide-details
                        disabled
                    ></v-select>
                    <v-menu
                        v-if="editTransaction.type != 'CC'"
                        v-model="editTransaction.datePickerMenu"
                        :close-on-content-click="true"
                        full-width
                        max-width="290"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                :value="formatedDate"
                                label="Date"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="editTransaction.date"
                            @change="datePickerMenu = false"
                        ></v-date-picker>
                    </v-menu>
                    <v-text-field
                        v-if="editTransaction.type != 'CC'"
                        class="mb-2"
                        label="Check Number"
                        ref="checkNumber"
                        v-model="editTransaction.checkNumber"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        label="Note"
                        v-model="editTransaction.note"
                    ></v-text-field>

                    <!-- <v-text-field
                        class="mb-2"
                        label="Receipt"
                        v-model="editTransaction.receipt"
                    ></v-text-field> -->
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="editDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="processUpdate"
                    >
                        update
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            v-model="confirmCheckPaymentUpdateDialog"
            max-width="400"
        >
            <v-card class="pa-2">
                <v-card-title class="headline px-3"
                    >Confirm Change</v-card-title
                >
                <div class="font-weight-medium mb-3 px-3">
                    This check is already receipted with receipt #{{
                        editTransaction.receipt
                    }}, Changing the date to a later date will clear the receipt
                    number and will mark the check as unprocessed. Do you want
                    to continue ?
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="confirmCheckPaymentUpdateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="savePaymentUpdate"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="addChargeDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-3">New Charge</v-card-title>
                <div class="px-3 pt-2">
                    <v-select
                        label="Student"
                        v-model="chargeStudent"
                        :items="studentsToCharge.map((s) => s.name)"
                        :rules="required"
                        ref="chargeStudent"
                        :disabled="studentsToCharge.length == 1"
                        @change="chargeStudentChanged"
                    >
                    </v-select>
                    <v-select
                        label="Charge Description"
                        v-model="chargeDescription"
                        :items="items.map((i) => i.description)"
                        @change="chargeNameChanged"
                        :rules="required"
                        ref="chargeDescription"
                        class="mb-2"
                    >
                    </v-select>
                    <v-layout row>
                        <v-text-field
                            class="pt-0 mr-3"
                            label="Quantity"
                            v-model="chargeQuantity"
                            type="number"
                            ref="chargeQuantity"
                            :rules="required"
                        ></v-text-field>
                        <v-text-field
                            class="pt-0"
                            label="Price"
                            v-model="chargePrice"
                            prefix="$"
                            type="number"
                            ref="chargePrice"
                            :rules="required"
                        ></v-text-field>
                        <div class="pt-3 ml-3 font-weight-medium">
                            ${{ (chargeQuantity * chargePrice).toFixed(2) }}
                        </div>
                    </v-layout>
                    <v-text-field
                        class="pt-0"
                        label="Note"
                        v-model="chargeNote"
                        ref="chargeNote"
                    ></v-text-field>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="addChargeDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveCharges"
                    >
                        save
                    </v-btn>
                </v-card-actions>
                <!-- <div class="pa-3 pt-0">
                    <v-select
                        label="Charge Description"
                        v-model="chargeName"
                        :items="['Transportation']"
                    >
                    </v-select>
                    <v-layout row v-for="student in studentsToCharge">
                        <v-checkbox
                            v-model="student.selected"
                            hide-details
                            class="pt-0"
                            color="success"
                            style="max-width: 34px;"
                        ></v-checkbox>
                        <div class="mr-3 pt-3">{{ student.name }}</div>
                        <v-text-field
                            class="mb-2"
                            type="number"
                            label="Amount"
                            ref="amount"
                            prefix="$"
                            v-model="student.amount"
                            :rules="amountRules"
                        ></v-text-field>
                    </v-layout>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="addChargeDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveCharges"
                        :disabled="!studentsToCharge.some((s) => s.selected)"
                    >
                        save
                    </v-btn>
                </v-card-actions> -->
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="deleteTransactionDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-3">Delete Charge</v-card-title>

                <div class="px-3 m-3">
                    The charge
                    <span class="font-weight-medium">{{
                        transactionToDelete.description
                    }}</span>
                    of
                    <span class="font-weight-medium">{{
                        transactionToDelete.amount | currency
                    }}</span>
                    will be deleted
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="deleteTransactionDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteCharge"
                    >
                        delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="newStudentDialog" max-width="400">
            <new-student
                ref="newStudent"
                :onCreated="onNewStudentCreated"
                :closeNewStudentModal="closeNewStudentModal"
                :account="account"
                :gradesSetup="gradesSetup"
            ></new-student>
        </v-dialog>
        <v-dialog v-model="emailReceiptDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Email Receipt</v-card-title>
                <v-text-field
                    class="px-3"
                    v-model="emailAddress"
                    :rules="emailRules"
                    ref="emailReceipt"
                ></v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="emailReceiptDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="emailingReceipt"
                        color="success"
                        @click="emailReceipt"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="uploadDocumentDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Upload Document</v-card-title>
                <v-combobox
                    class="px-3"
                    autocomplete="new-password"
                    :items="documentTypes"
                    label="Document Type"
                    v-model="documentType"
                    ref="documentType"
                    :rules="required"
                ></v-combobox>
                <v-layout row>
                    <v-btn
                        small
                        outline
                        :disabled="currentRegID != regID"
                        class="mr-2 ml-3 mb-4 mt-0"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <div v-if="files.length" class="mt-2 ml-2">
                        {{ files[0].name }}
                    </div></v-layout
                >
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept="image/*,.pdf"
                    @change="onFilePicked($event)"
                />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="closeUploadDocumentDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!files.length"
                        :loading="processing"
                        color="success"
                        @click="saveDocument()"
                    >
                        Save Document
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import editTransaction from "./EditTransaction.vue";
import addStudent from "./AddStudent.vue";
import moment from "moment";
import { loadOptions } from "../../utils/smLookup.js";
import newStudent from "./newStudent.vue";
import {
    getDomain,
    except,
    toTitleCase,
    truncate,
} from "../../utils/helpers.js";
import transactionPaymentDetails from "../Payment/TransactionPaymentDetails.vue";

export default {
    props: {
        loading: Boolean,
        transactions: Array,
        immunizationsDocuments: Array,
        account: Object,
        lapidusAccount: Object,
        refresh: Function,
        country: String,
        regID: String,
        currentRegID: String,
        openDialogForStudent: Object,
        openPaymentModal: Function,
        printStatement: Function,
        openEmailStatementDialog: Function,
        openNewCreditCardModal: Function,
    },
    components: {
        "edit-transaction": editTransaction,
        "add-student": addStudent,
        newStudent: newStudent,
        transactionPaymentDetails,
    },
    data() {
        return {
            activeTab: "all",
            editingStudent: null,

            confirmationMessage: "",
            confirmDialog: false,
            confirmAction: null,
            refundReason: "",
            refundAmount: 0,
            refundTransactionAmount: {},
            paymentTypes: [],

            editDialog: false,
            newStudents: [],
            gradesSetup: [],

            editTransaction: {
                transactionID: "",
                amount: "",
                type: "",
                note: "",
                receipt: "",
                date: "",
                checkNumber: "",
                datePickerMenu: false,
                amountRules: [
                    (v) => !!v || "Amount Is Required",
                    (v) => !v || v > 0 || "Amount Can't Be Negative",
                ],
            },

            newStudentDialog: false,

            processing: false,

            uploading: false,
            files: [],
            documentTypes: [],
            documentType: "",
            uploadDocumentForStudent: "",
            uploadDocumentDialog: false,

            emailAddress: "",
            receiptToEmail: {},
            emailReceiptDialog: false,
            emailingReceipt: false,

            addChargeDialog: false,

            items: [],

            chargeDescription: "",
            chargeQuantity: "",
            chargeNote: "",
            chargePrice: "",
            chargeStudent: "",

            chargeName: "Transportation",
            studentsToCharge: [],

            transactionToDelete: "",
            deleteTransactionDialog: false,
            confirmCheckPaymentUpdateDialog: false,

            emailRules: [
                (value) => !!value || "Required.",
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            ],

            required: [(value) => !!value || "Required."],

            refundAmountRules: [
                (value) => {
                    if (value) {
                        return (
                            value <= this.refundTransactionAmount ||
                            "Can't be more than Payment Amount"
                        );
                    }

                    return !!value || "Refund Amount Is Required";
                },
            ],

            amountRules: [(v) => !!v || v == 0 || "Amount Is Required"],

            isGirls: false,
        };
    },
    async created() {
        this.isGirls = this.$route.query.isGirls;

        await this.loadPaymentTypes();
        await this.loadGradesSetup();
        await this.loadDocumentTypes();
        await this.loadLapidusItems();

        if (this.$route.query.voucherPayment) {
            this.openPaymentModal({
                countryVoucher: true,
                voucherAccount: this.$route.query.voucherAccount,
            });
        }
    },
    watch: {
        openDialogForStudent(newValue, oldValue) {
            if (this.openDialogForStudent && !this.editingStudent) {
                this.openTransactionDialog(this.openDialogForStudent);
            }
        },
    },
    computed: {
        formatedDate() {
            return this.editTransaction.date
                ? moment(new Date(this.editTransaction.date)).format("L")
                : "";
        },
    },
    methods: {
        async loadPaymentTypes() {
            this.paymentTypes = await this.$http.get(
                "api/payments/getPaymentTypes?categoryCode=LAPC",
            );

            // this.paymentTypes = (await loadOptions("paymentType"))
            //     .map((v) => v.value)
            //     .filter((v) => v != "Credit Card");
        },
        async loadDocumentTypes() {
            const documentTypes = await this.$http.get(
                "api/lapidusDayCamp/GetDocumentTypeList",
            );

            this.documentTypes = documentTypes.filter((d) => d != "LUNCH");

            if (!this.documentTypes.includes("IMMUNIZATION")) {
                this.documentTypes.push("IMMUNIZATION");
            }

            this.documentType = "IMMUNIZATION";

            // if (!this.documentTypes.includes("LUNCH")) {
            //     this.documentTypes.push("LUNCH");
            // }
        },
        getStatementActions() {
            return [
                { text: "Print", action: this.printStatement },
                { text: "Email", action: this.openEmailStatementDialog },
            ];
        },
        getTabList() {
            switch (this.activeTab) {
                case "bills":
                    return this.transactions.filter((t) => t.txnType == "D");
                case "payments":
                    return this.transactions.filter((t) => t.txnType == "C");
                default:
                    return this.transactions;
            }
        },
        getTransactionTitle(transaction) {
            if (transaction.txnType == "C")
                return this.isScheduled(transaction.date)
                    ? "Scheduled Payment - " +
                          moment(transaction.date).format("L")
                    : "Payment - " + moment(transaction.date).format("L");

            const description =
                transaction.description.startsWith("Lapidus Chider") ||
                transaction.description.startsWith("Lapidus Day Camp")
                    ? ""
                    : " - " + transaction.description;

            const student = transaction.student;

            if (transaction.description == "Previous Balance")
                return transaction.description;

            if (!student.name)
                return (
                    `Missing Name (${transaction.student.enrollment.class})` +
                    description
                );

            return (
                `${student.name} - ${student.hebName} (${student.class})` +
                description
            );
        },

        getTransactionStatus(transaction) {
            if (transaction.txnType == "D") return "BILL";

            if (this.isPastDue(transaction)) return "SCHEDULED PAST DUE";

            return transaction.paymentStatus;
        },
        isPastDue(transaction) {
            const today = new Date();

            if (
                this.getPaymentType(transaction) == "Cash/Check" ||
                (transaction.schedules &&
                    transaction.schedules.some((s) => s.status == "Scheduled"))
            ) {
                return (
                    new Date(transaction.date) < today &&
                    (transaction.paymentStatus == "SCHEDULED" ||
                        !transaction.receiptNumber)
                );
            }
        },
        getStatusIcon(transaction) {
            if (transaction.txnType == "D") return "mdi-currency-usd";

            if (this.isPastDue(transaction)) return "mdi-alert-octagon";

            if (!transaction.paymentStatus) return "";

            switch (transaction.paymentStatus.toUpperCase()) {
                case "PROCESSED":
                    return "mdi-check-circle";
                case "DECLINED":
                    return "mdi-alert";
                case "ERROR":
                    return "mdi-alert-circle";
                case "SCHEDULED":
                    return "mdi-clock";
                default:
                    return "";
            }
        },
        getStatusIconColor(transaction) {
            if (transaction.txnType == "D") return "success";

            if (this.isPastDue(transaction)) return "#f35123";

            if (!transaction.paymentStatus) return "#aeb8bf";

            switch (transaction.paymentStatus.toUpperCase()) {
                case "PROCESSED":
                    return "success";
                case "DECLINED":
                case "ERROR":
                    return "#f35123";
                case "SCHEDULED":
                    return "#fdb400";
                default:
                    return "#aeb8bf";
            }
        },
        getPaymentsTitle(payments) {
            return payments.length == 1
                ? "Payment"
                : "Payments (" + payments.length + ")";
        },
        getSuccessfulPayment(payments) {
            return payments.find((p) => p.status == "PROCESSED");
        },
        getFailedPayments(payments) {
            return payments.filter((p) => p.status != "PROCESSED");
        },
        getFailedPaymentsTitle(payments) {
            return this.getFailedPayments(payments).length == 1
                ? "Failed Payment"
                : "Failed Payments (" + payments.length + ")";
        },
        getPaymentStatusIcon(payment) {
            switch (payment.statusValue.toUpperCase()) {
                case "PROCESSED":
                    return "mdi-check-circle";
                case "DECLINED":
                    return "mdi-alert";
                case "ERROR":
                    return "mdi-alert-circle";
                case "SCHEDULED":
                    return "mdi-clock";
                default:
                    return "";
            }
        },
        getPaymentStatusIconColor(payment) {
            switch (payment.statusValue.toUpperCase()) {
                case "PROCESSED":
                    return "success";
                case "DECLINED":
                case "ERROR":
                    return "#f35123";
                case "SCHEDULED":
                    return "#fdb400";
                default:
                    return "#aeb8bf";
            }
        },
        expandPayment(payment, transaction) {
            if (!payment) return;

            payment.expanded = !payment.expanded;

            transaction.payments
                .filter((p) => p.paymentID != payment.paymentID)
                .forEach((p) => {
                    p.expanded = false;
                });

            this.$forceUpdate();
        },
        hasSchedule(schedules) {
            return schedules.length;
        },
        getScheduleDate(schedules) {
            if (!this.hasSchedule(schedules)) return;

            return schedules[0].scheduleDate;
        },
        getEnabledStatus(schedules) {
            if (!this.hasSchedule(schedules)) return;

            return schedules[0].isEnabled ? "Yes" : "No";
        },
        // getSchedulesTitle(schedules) {
        //     return "Schedule Details";
        // },
        // getScheduleStatusIcon(schedule) {
        //     if (schedule.status.toUpperCase().startsWith("ERROR"))
        //         return "mdi-alert-circle";

        //     switch (schedule.status.toUpperCase()) {
        //         case "PROCESSED":
        //         case "APPROVED":
        //             return "mdi-check-circle";
        //         case "DECLINED":
        //             return "mdi-alert";
        //         case "ERROR":
        //             return "mdi-alert-circle";
        //         case "SCHEDULED":
        //             return "mdi-clock";
        //         default:
        //             return "";
        //     }
        // },
        // getScheduleStatusIconColor(schedule) {
        //     if (schedule.status.toUpperCase().startsWith("ERROR"))
        //         return "#f35123";

        //     switch (schedule.status.toUpperCase()) {
        //         case "PROCESSED":
        //         case "APPROVED":
        //             return "success";
        //         case "DECLINED":
        //         case "ERROR":
        //             return "#f35123";
        //         case "SCHEDULED":
        //             return "#fdb400";
        //         default:
        //             return "#aeb8bf";
        //     }
        // },
        // expandSchedule(schedule, transaction) {
        //     if (!schedule) return;

        //     schedule.expanded = !schedule.expanded;

        //     transaction.schedules
        //         .filter((p) => p.scheduleDetailID != schedule.scheduleDetailID)
        //         .forEach((p) => {
        //             p.expanded = false;
        //         });

        //     this.$forceUpdate();
        // },
        isScheduled(date) {
            return new Date() < new Date(date);
        },
        getPaymentDescription(transaction) {
            return (
                this.getPaymentType(transaction) +
                (transaction.receiptNumber
                    ? " | Receipt #" + transaction.receiptNumber
                    : "")
            );
        },
        getTransactionAmount(transaction) {
            if (
                ["Refund", "Void"].includes(this.getPaymentType(transaction)) ||
                transaction.amount < 0
            )
                return "-$" + Math.abs(transaction.amount);

            return "$" + transaction.amount;
        },
        getPaymentType(transaction) {
            if (transaction.txnType == "D") return;

            if (transaction.description.startsWith("CK")) return "ACH";

            if (transaction.description.startsWith("Country Voucher"))
                return "Country Voucher";

            return !transaction.description.includes(" ")
                ? transaction.description
                : transaction.description.substr(
                      0,
                      transaction.description.indexOf(" "),
                  );
        },
        isDeclined(transaction) {
            if (transaction.txnType != "C") return;

            return (
                transaction.paymentStatus &&
                transaction.paymentStatus.toUpperCase() == "DECLINED"
            );

            // return (
            //     (transaction.payment &&
            //         transaction.payment.status == "DECLINED") ||
            //     (transaction.schedule &&
            //         transaction.schedule.status == "Declined")
            // );
        },
        isError(transaction) {
            if (transaction.txnType != "C") return;

            return (
                transaction.paymentStatus &&
                transaction.paymentStatus.toUpperCase() == "ERROR"
            );

            // return (
            //     (transaction.payment &&
            //         transaction.payment.status == "ERROR") ||
            //     (transaction.schedule &&
            //         transaction.schedule.status.startsWith("Error"))
            // );
        },
        getProperties(transaction) {
            return Object.keys(
                except(
                    transaction,
                    "payment",
                    "payments",
                    "schedule",
                    "schedules",
                    "student",
                    "date",
                    "receiptNumber",
                    "userUpdated",
                    "lastUpdated",
                    "dateCreated",
                    "checkDetails",
                    "scheduleDetailID",
                    "date",
                    "byUser",
                ),
            )
                .map((key) => {
                    return {
                        name: toTitleCase(key),
                        value: transaction[key],
                    };
                })
                .filter((p) => p.value);
        },
        getPaymentProperties(payment) {
            if (!payment) return;

            return Object.keys(
                except(
                    payment,
                    "accountID",
                    "name",
                    "amount",
                    "paymentType",
                    "status",
                    "statusIcon",
                    "source",
                    "scheduleDetailID",
                    "scheduleID",
                    "paymentMethodID",
                    "expanded",
                ),
            )
                .map((key) => {
                    return {
                        name: toTitleCase(key),
                        value: payment[key],
                    };
                })
                .filter((p) => p.value);
        },
        getScheduleProperties(schedule) {
            if (!schedule) return;

            return Object.keys(
                except(
                    schedule,
                    "accountID",
                    "name",
                    "date",
                    "scheduleDate",
                    "dateCreated",
                    "amount",
                    "paymentType",
                    "source",
                    "scheduleDetailID",
                    "scheduleID",
                    "statusIcon",
                    "paymentMethodID",
                    "userUpdated",
                    "lastUpdated",
                    "expanded",
                ),
            )
                .map((key) => {
                    return {
                        name: toTitleCase(key),
                        value: schedule[key],
                    };
                })
                .filter((p) => p.name == "IsEnabled" || p.value);
        },
        getRegisteredWeeks(transaction) {
            const weeks = Object.keys(transaction.student.enrollment)
                .map((key) => {
                    if (
                        !key.startsWith("week") ||
                        !transaction.student.enrollment[key]
                    )
                        return;

                    return key.substring(4);
                })
                .filter(Boolean);

            return weeks.join(", ");
        },
        truncateText(text) {
            return truncate(text, 50);
        },
        async addStudent() {
            this.newStudents = await this.loadStudents();

            this.openTransactionDialog({
                enrollment: {},
            });
        },
        async loadStudents() {
            let students = await this.$http.get(
                `api/lapidusDayCamp/getStudents?linkId=${
                    this.account.accountLinkID
                }&pin=${this.account.pinNum}`,
            );

            const enrolledStudents = await this.$http.get(
                "api/lapidusDayCamp/GetEnrolledStudents?accountID=" +
                    this.account.accountID +
                    "&regID=" +
                    this.regID,
            );

            // if (this.isGirls) {
            //     students = students.filter((s) => s.class.startsWith("G"));
            // } else {
            //     students = students.filter((s) => s.class.startsWith("B"));
            // }

            return students.filter(
                (s) =>
                    !enrolledStudents
                        .map((student) => student.studentID)
                        .includes(s.studentID),
            );
        },
        async loadGradesSetup() {
            this.gradesSetup = await this.$http.get(
                "api/lapidusDayCamp/getGradesSetup",
            );
        },
        hasDayCamp(student) {
            return this.gradesSetup.find((g) => g.grade == student.class)
                .isCountryAvail;
        },
        newStudentSelected(student) {
            if (!student) {
                this.editingStudent = {
                    enrollment: {},
                };

                return;
            }

            this.editingStudent = {
                isEnrolled: false,
                enrollment: {
                    regType: "NONE",
                    week1: false,
                    week2: false,
                    week3: false,
                    week4: false,
                    week5: false,
                    week6: false,
                    week7: false,
                    week8: false,
                    week9: false,
                },
                name: student.engName,
                studentID: student.studentID,
                hebName: student.hebName,
                class: student.class,
                chosenClass: "",
            };
        },
        openTransactionDialog(student) {
            this.editingStudent = student;

            this.$refs.editTransaction.openDialog(
                JSON.parse(JSON.stringify(student)),
            );
        },
        openDeleteDialog(transaction) {
            this.transactionToDelete = transaction;
            this.deleteTransactionDialog = true;
        },
        async deleteCharge() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/lapidusDayCamp/DeleteCharge?id=" +
                        this.transactionToDelete.txnID,
                );

                this.deleteTransactionDialog = false;
                this.processing = false;
                this.refresh();
            } catch (e) {
                this.processing = false;
            }
        },
        async processAction() {
            if (this.isRefunding() && !this.$refs.refundAmount.validate(true))
                return;

            this.processing = true;

            try {
                await this.confirmAction();
            } catch (e) {
                this.processing = false;

                return;
            }

            if (this.isRefunding()) {
                this.$notify({
                    text: "Payment Refunded",
                    group: "notification",
                    type: "success",
                });
            }

            this.processing = false;

            this.confirmDialog = false;
            this.refundTransactionAmount = {};

            this.refresh();
        },
        updatePayment(transaction) {
            var lastIndex = transaction.description.lastIndexOf("#");
            const receipt = transaction.description.substring(lastIndex + 1);

            this.editTransaction.transactionID = transaction.txnID;
            this.editTransaction.receipt = transaction.receiptNumber;
            this.editTransaction.date = new Date(transaction.date)
                .toISOString()
                .substr(0, 10);
            this.editTransaction.amount = transaction.amount;
            this.editTransaction.type = this.getPaymentType(transaction);
            this.editTransaction.note = transaction.note;
            this.editTransaction.checkNumber = this.getCheckNumber(transaction);

            this.editDialog = true;
        },
        getCheckNumber(transaction) {
            if (this.getPaymentType(transaction) == "CC") return "";

            var index = transaction.description.indexOf("#");
            const value = transaction.description.substring(index + 1);

            return value.substring(0, value.indexOf(" "));
        },
        getCheckDetails(transaction) {
            if (
                this.getPaymentType(transaction) != "Cash/Check" &&
                (!transaction.checkDetails || !transaction.checkDetails.length)
            )
                return [];

            if (
                this.getPaymentType(transaction) == "Cash/Check" &&
                (!transaction.checkDetails || !transaction.checkDetails.length)
            ) {
                return [
                    {
                        checkNumber: this.getCheckNumber(transaction),
                        date: transaction.date,
                        amount: transaction.amount,
                    },
                ];
            }

            return transaction.checkDetails;
        },
        needsToConfrimCheckUpdate(transaction) {
            const moveToLaterDate = new Date(transaction.date) > new Date();

            const originalTransaction = this.transactions.find(
                (t) => t.txnID == transaction.transactionID,
            );

            return (
                this.editTransaction.type == "Cash/Check" &&
                this.getTransactionStatus(originalTransaction) == "PROCESSED" &&
                moveToLaterDate
            );
        },
        openConfirmCheckPaymentUpdate() {
            this.confirmCheckPaymentUpdateDialog = true;
        },
        async processUpdate() {
            if (
                this.editTransaction.type != "CC" &&
                !this.$refs.amount.validate(true)
            )
                return;

            if (this.needsToConfrimCheckUpdate(this.editTransaction)) {
                return this.openConfirmCheckPaymentUpdate();
            }

            await this.savePaymentUpdate();
        },
        async savePaymentUpdate() {
            this.processing = true;

            const {
                transactionID,
                receipt,
                date,
                amount,
                type,
                note,
                checkNumber,
            } = this.editTransaction;

            const data = {
                transactionID,
                receipt,
                date,
                amount,
                note,
                checkNumber: type == "Check" ? checkNumber : "",
                paymentType: type,
                user: this.$store.state.authentication.user,
            };

            try {
                await this.$http.post(
                    "api/lapidusDayCamp/UpdateTransaction",
                    data,
                );
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;

            this.editDialog = false;
            this.confirmCheckPaymentUpdateDialog = false;

            this.refresh();
        },
        allowRefund(transaction) {
            return (
                this.getPaymentType(transaction) == "CC" &&
                moment(new Date(transaction.date)).isBefore(new Date())
            );
        },
        isRefunding() {
            return this.confirmationMessage.includes("Refund/Void");
        },
        voidPayment(transaction) {
            this.confirmationMessage = "Refund/Void Payment";

            this.refundAmount = transaction.amount;
            this.refundTransactionAmount = transaction.amount;

            this.confirmAction = () => {
                return this.$http.post(`api/lapidusDayCamp/VoidPayment`, {
                    accountID: this.account.accountID,
                    user: this.$store.state.authentication.user,
                    paymentID: this.getSuccessfulPayment(transaction.payments)
                        .paymentID,
                    isGirls: this.isGirls,
                    amount: this.refundAmount,
                    reason: this.refundReason,
                    regID: this.regID,
                    categoryCode: this.isGirls ? "LPDC" : "LAPC",
                    categoryDescription: this.isGirls
                        ? "Lapidus Day Camp"
                        : "Lapidus Chider",
                });
            };

            this.confirmDialog = true;
        },
        getSuccessfulPayment(payments) {
            return payments.find((p) => p.status == "PROCESSED");
        },
        deletePayment(transaction) {
            this.confirmationMessage =
                "This will delete the payment of $" + transaction.amount;

            this.confirmAction = () => {
                return this.$http.post(
                    "api/lapidusDayCamp/DeleteTransaction?transactionID=" +
                        transaction.txnID +
                        "&user=" +
                        this.$store.state.authentication.user,
                );
            };

            this.confirmDialog = true;
        },
        isLaterDate(date) {
            return moment(new Date(date)).isAfter(new Date());
        },
        cancelScheduledPayment(transaction) {
            if (!transaction.scheduleDetailID) {
                this.$notify({
                    group: "notification",
                    text: "Can't cancel payment without Schedule ID.",
                    type: "error",
                });

                return;
            }

            this.confirmationMessage =
                "This will cancel the payment of $" +
                transaction.amount +
                " scheduled for " +
                moment(transaction.date).format("L");

            this.confirmAction = () => {
                return this.$http.post(
                    "api/lapidusDayCamp/DeleteTransaction?transactionID=" +
                        transaction.txnID +
                        "&user=" +
                        this.$store.state.authentication.user,
                );
            };

            this.confirmDialog = true;
        },
        closeNewStudentModal() {
            this.newStudentDialog = false;
        },
        onNewStudentCreated(student) {
            const existing = this.transactions
                .filter((t) => t.txnType == "D")
                .find((s) => s.student.studentID == student.studentID);

            existing.engName = student.engName;
            existing.name = student.engName;
            existing.hebName = student.hebName;
            existing.dob = student.dob;
            existing.class = student.class;

            this.newStudentDialog = false;

            this.refresh();
        },
        editStudentInfo(student) {
            this.$refs.newStudent.prefill(student);

            this.newStudentDialog = true;
        },
        openUploadDocumentDialog(student) {
            this.uploadDocumentForStudent = student;

            this.uploadDocumentDialog = true;
        },
        closeUploadDocumentDialog(student) {
            this.uploadDocumentDialog = false;
            this.files = [];
        },
        pickFile() {
            // const index = this.transactions
            //     .filter((t) => t.txnType == "D")
            //     .indexOf(transaction);

            // this.$refs.files[index].click();
            this.$refs.files.click();
        },

        async onFilePicked(e, student) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            this.uploading = false;
        },
        async saveDocument() {
            if (
                !this.$refs.documentType.validate(true) ||
                (Array.isArray(this.documentType) && !this.documentType.length)
            ) {
                this.$notify({
                    group: "notification",
                    text: "Missing Document Type",
                    type: "error",
                });

                return;
            }

            this.processing = true;

            try {
                var formData = new FormData();

                formData.append("image", this.files[0]);

                await this.$http.post(
                    "api/lapidusDayCamp/UploadFile?accountID=" +
                        this.account.accountID +
                        "&studentID=" +
                        this.uploadDocumentForStudent.studentID.trim() +
                        "&documentType=" +
                        this.documentType +
                        "&user=" +
                        this.$store.state.authentication.user,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.processing = false;
                this.uploadDocumentDialog = false;
                this.files = [];
                this.documentType = [];

                this.refresh();
            } catch (e) {
                this.processing = false;
            }
        },
        async openDocument(immunizationDocument) {
            const url = await this.$http.get(
                "/api/lapidusDayCamp/GetImmunizationsDocument?filePath=" +
                    immunizationDocument.fileURL,
            );

            window.open(url);
        },
        getDocumentsForStudent(student) {
            return this.immunizationsDocuments.filter(
                (doc) => doc.studentID == student.studentID.trim(),
            );
        },
        deleteDocument(document) {
            this.confirmationMessage =
                "This will delete the immunization document";

            this.confirmAction = () => {
                return this.$http.post(
                    "api/lapidusDayCamp/DeleteFile?documentID=" +
                        document.documentID +
                        "&documentType=" +
                        document.category,
                );
            };

            this.confirmDialog = true;
        },
        getReceiptNumber(transaction) {
            const lastIndex = transaction.description.lastIndexOf("#");
            const lastSegment = transaction.description.substring(
                lastIndex + 1,
            );

            return lastSegment.trim() == this.getPaymentType(transaction)
                ? ""
                : lastSegment;
        },
        createReceipt(transaction) {
            const receipt = this.getReceiptNumber(transaction);

            let html = `<!DOCTYPE html>
                <html style="margin: 10px; padding: 10px; border-style: solid;">
                <head>
                <style>
                table {
                  font-family: arial, sans-serif;
                  border-collapse: collapse;
                }

                td, th {
                  padding: 6px;
                }
                .no-border td, th {
                    border: none;
                }
                .account-info {
                    font-family: arial, sans-serif;
                    text-align: left;
                }
                .regular-text {
                    margin-bottom: 5px;
                    margin-top: 0px;
                }
                .title {
                    font-size: 25px;
                }
                </style>
                </head>
                <body>`;

            if (!this.isGirls) {
                html += `<p class="regular-text" style="text-align: center;"><span style="font-size: 13pt;"><strong><span style="font-family: arial, helvetica, sans-serif;">ת"ת תורה ויראה דרבינו יואל מ'סאטמאר</span> </strong></span></p>`;
            } else {
                html += `<p class="regular-text" style="text-align: center;"><span style="font-size: 13pt;"><strong><span style="font-family: arial, helvetica, sans-serif;"></span>דעי קעמפ</strong></span></p>`;
            }

            html += `<p class="regular-text" style="text-align: center;"><span style="font-size: 11pt;"><span style="font-family: arial, helvetica, sans-serif;">שע"י סאטמאר באנגעלאו קאלאני</span></span></p>
                            <p>&nbsp;</p>

                <p style="text-align: center;" class="account-info title"><strong>Receipt ${
                    receipt ? "#" + receipt : ""
                }</strong></p>

                <p style="text-align: right;" class="account-info"><strong>${moment(
                    transaction.date,
                ).format("L")}</strong></p>

                <div class="account-info">
                <p class="regular-text"><strong>${
                    this.account.name
                }</strong></p>
                <p class="regular-text"><strong>Address: </strong>${
                    this.account.address1
                }</p>
                <p class="regular-text"><strong>Phone: </strong>${
                    this.account.homePhone
                }</p>`;

            if (this.account.emailAddress) {
                html += `<p class="regular-text"><strong>Email: </strong>${
                    this.account.emailAddress
                }</p>`;
            }

            html += `<p class="regular-text"><strong>Country: </strong>${
                this.lapidusAccount.country
            }</p>
                            </div>`;

            html += `<table class="no-border" align="right" style="width: 35%;" border="1">
                    <tbody>
                    <tr>

                    <td>Payment Type</td>
                    <td style="text-align: right;"><strong>${this.getPaymentType(
                        transaction,
                    )}</strong></td>
                    </tr>
                    <tr>

                    <td>Payment Amount</td>
                    <td style="text-align: right;"><strong>$${
                        transaction.amount
                    }</strong></td>
                    </tr>
                    <tr>
                    <td>Balance</td>
                    <td style="text-align: right;"><strong>$${
                        this.lapidusAccount.balance
                    }</strong></td>
                    </tr>
                    </tbody>
                    </table>
                    </body>
                </html>`;

            return html;
        },
        printReceipt(transaction) {
            const newWindow = window.open(
                "",
                "Receipt",
                "width=800, height=800",
            );

            newWindow.document.write(this.createReceipt(transaction));
        },
        openEmailReceiptDialog(transaction) {
            this.receiptToEmail = transaction;

            this.emailAddress = this.account.emailAddress;

            this.emailReceiptDialog = true;
        },
        async emailReceipt() {
            if (!this.$refs.emailReceipt.validate(true)) return;

            this.emailingReceipt = true;

            try {
                await this.$http.post("api/lapidusDayCamp/emailLetter", {
                    emailAddress: this.emailAddress,
                    html: this.createReceipt(this.receiptToEmail),
                    subject: this.isGirls
                        ? "Lapidus Day Camp Receipt"
                        : "Lapidus Cheider Receipt",
                    emailFrom: this.isGirls ? "Lapidus Day Camp" : null,
                });

                this.$notify({
                    text: "Email Sent",
                    group: "notification",
                    type: "success",
                });

                this.emailReceiptDialog = false;
            } catch (e) {
            } finally {
                this.emailingReceipt = false;
            }
        },
        openChangeAmountDialog() {
            this.changeAmountDialog = true;
        },
        async loadLapidusItems() {
            const response = await this.$http.get(
                "api/lapidus/getBillingSetup?categoryCode=" +
                    (this.isGirls ? "LPDC" : "LAPC"),
            );

            this.items = response.map((item) => {
                item.quantity = "";
                item.price = item.unitPrice;

                return item;
            });
        },
        openAddChargeDialog() {
            this.studentsToCharge = this.transactions
                .filter(
                    (t) =>
                        t.student &&
                        t.student.enrollment &&
                        (t.description.startsWith("Lapidus Chider") ||
                            t.description.startsWith("Lapidus Day Camp")),
                )
                .map((s) => ({
                    selected: true,
                    studentID: s.student.studentID,
                    name: s.student.engName,
                    enrollment: s.student.enrollment,
                    enrollmentID: s.student.enrollment.id,
                    isGirl: s.student.class.startsWith("G"),
                    amount: this.getTransportationAmount(s.student.enrollment),
                }));

            if (this.studentsToCharge.length == 1) {
                this.chargeStudent = this.studentsToCharge[0].name;
            }

            this.chargeQuantity = 1;

            this.addChargeDialog = true;
        },
        chargeNameChanged(value) {
            //const item = this.items.find((i) => i.description == value);
            const student = this.studentsToCharge.find(
                (s) => s.name == this.chargeStudent,
            );

            if (value == "Country Transportation") {
                this.chargePrice = student
                    ? this.getTransportationAmount(student.enrollment)
                    : 0;
            }
        },
        chargeStudentChanged(value) {
            const student = this.studentsToCharge.find(
                (s) => s.name == this.chargeStudent,
            );

            if (value == "Country Transportation") {
                this.chargePrice = student
                    ? this.getTransportationAmount(student.enrollment)
                    : 0;
            }
        },
        getTransportationAmount(enrollment) {
            switch (enrollment.regType) {
                case "FULL":
                    return 100;
                case "HALF 1":
                case "HALF 2":
                    return 50;
                case "CUSTOM":
                    const explicitWeeks = {
                        week1: enrollment.week1,
                        week2: enrollment.week2,
                        week3: enrollment.week3,
                        week4: enrollment.week4,
                        week5: enrollment.week5,
                        week6: enrollment.week6,
                        week7: enrollment.week7,
                        week8: enrollment.week8,
                        week9: enrollment.week9,
                    };

                    const weekCount = Object.keys(explicitWeeks)
                        .map((key) => explicitWeeks[key])
                        .filter(Boolean).length;

                    return Math.min(weekCount * 15, 100);
                default:
                    return 0;
            }
        },
        async saveCharges() {
            if (
                !this.$refs.chargeDescription.validate(true) ||
                !this.$refs.chargeStudent.validate(true) ||
                !this.$refs.chargeQuantity.validate(true) ||
                !this.$refs.chargePrice.validate(true)
            )
                return;

            try {
                this.processing = true;

                const item = this.items.find(
                    (i) => i.description == this.chargeDescription,
                );

                const student = this.studentsToCharge.find(
                    (s) => s.name == this.chargeStudent,
                );

                await this.$http.post("api/lapidusDayCamp/addCharge", {
                    user: this.$store.state.authentication.user,
                    regID: this.regID,
                    accountID: this.account.accountID,
                    note: this.chargeNote,
                    dayCampID: student.enrollmentID,
                    invoiceDetail: {
                        itemCode: item.itemCode,
                        description: item.description,
                        quantity: this.chargeQuantity,
                        unitPrice: this.chargePrice,
                        amount: (
                            this.chargeQuantity * this.chargePrice
                        ).toFixed(2),
                        categoryCode: this.isGirls ? "LPDC" : "LAPC",
                    },
                });

                this.$notify({
                    text: "Charges Saved",
                    group: "notification",
                    type: "success",
                });

                this.processing = false;
                this.addChargeDialog = false;
                this.refresh();
            } catch (e) {
                this.processing = false;
            }
        },
        showStudentInfo(transaction) {
            return (
                transaction.txnType == "D" &&
                (transaction.description.startsWith("Lapidus Chider") ||
                    transaction.description.startsWith("Lapidus Day Camp"))
            );
        },
    },
};
</script>
<style>
.v-btn__content {
    color: unset;
}
/*
.lapidus-transaction-button
    .v-btn
    .v-btn--disabled
    .v-btn--small
    .theme--dark
    .default--text {
    color: rgba(0, 0, 0, 0.26) !important;
    background-color: rgba(0, 0, 0, 0.12) !important;
}*/

/*.lapidus-transaction-button.theme--dark.v-btn.v-btn--disabled,
.theme--dark.v-btn.v-btn--disabled .v-btn__loading,
.theme--dark.v-btn.v-btn--disabled .v-icon {
    color: rgba(0, 0, 0, 0.26) !important;
}

.lapidus-transaction-button.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    background-color: rgba(0, 0, 0, 0.12) !important;
}*/
</style>
